<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ isNew ? "Створення Платника" : "Платник" }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Payer"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" class="pb-0">
                <CustomTextField
                  v-model="title"
                  label="Найменування*"
                  class="ma-1"
                  :error-messages="$v.title.$error ? errors.TITLE : []"
                  :hide-details="false"
                  @input="$v.title.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="6" cols="12" class="mt-n4">
                <v-select
                  v-model="clientType"
                  :items="clientTypes"
                  return-object
                  label="Юр/Фіз особа"
                  hide-details
                  class="ma-1"
                  dense
                  outlined
                  @input="isChanged = true"
                />
              </v-col>

              <v-col sm="6" cols="12" class="mt-n4">
                <CustomTextField
                  v-model="code"
                  :disabled="!clientType"
                  :label="
                    clientType
                      ? clientType.value === 0
                        ? 'ЄДРПОУ'
                        : 'ІПН'
                      : ''
                  "
                  class="ma-1"
                  @input="isChanged = true"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <ClientSelect
                  v-model="client"
                  class="ma-1"
                  :client-id="client && client.id"
                  @input="isChanged = true"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <PrimaryBtn
              :has-warnings="$v.$invalid"
              :loading="loading"
              @click="save"
            />
            <v-btn v-if="!modal" @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClientSelect from "@/components/selects/ClientSelect";
import * as payersApi from "../../../backend/payersApi.js";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    ClientSelect,
    PrimaryBtn,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    title: "",
    code: "",
    clientType: null,
    clientTypes: [
      { text: "Юридична особа", value: 0 },
      { text: "Фізична особа", value: 1 },
    ],
    client: null,
    loading: false,
    isChanged: false,
  }),

  validations: {
    title: {
      required,
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (+this.id) {
      payersApi.getPayer(this.id).then((payer) => {
        this.title = payer.title;
        this.code = payer.code;
        if (payer.isPrivatePerson) {
          this.clientType = this.clientTypes.find((t) => t.value === 1);
        } else {
          this.clientType = this.clientTypes.find((t) => t.value === 0);
        }
        this.client = payer.client;
      });
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;

      const payer = {
        title: this.title,
        code: this.code,
        isPrivatePerson: this.clientType.value === 1,
        clientId: this.client ? this.client.id : null,
      };

      try {
        if (!this.isNew) {
          await payersApi.updatePayer(this.id, payer);
        } else {
          await payersApi.createPayer(payer);
        }
        this.$notifySuccess();
        this.modal ? this.$emit("close") : this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
  },
};
</script>
